export default __webpack_public_path__ + "static/media/CheeseGraterRegular-DOn4d.c3dcdb77.ttf";